
























































































































import {
  computed, defineComponent, ref, Ref, onMounted,
}                         from '@vue/composition-api';
import useOptions         from '@/components/composers/useOptions';
import useHandleDrawer    from '@/components/composers/useHandleDrawer';
import useManualMapUpdate from '@/components/composers/useManualMapUpdate';
import Clock              from '@/components/structural/Clock.vue';
import MainIcon           from '@/components/structural/MainIcon.vue';
import ContrastSwitcher   from '@/components/structural/ContrastSwitcher.vue';
import FontsizeSwitcher   from '@/components/structural/FontsizeSwitcher.vue';
import useOverlay         from '@/components/composers/useOverlay';
import router             from '@/routes/routes';
import store              from '@/store/index';

const TopBar = defineComponent({
  name: 'TopBar',
  components: {
    Clock,
    MainIcon,
    ContrastSwitcher,
    FontsizeSwitcher,
  },
  setup() {
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
    const menuSwitcher: Ref<boolean> = ref(false);
    const overlay = useOverlay();

    const closeSwitcher = (): boolean => {
      menuSwitcher.value = false;
      return true;
    };

    const showMap = () => {
      closeSwitcher();
      overlay.hideOverlay();
      router.push({ name: 'Map' });
    };

    const switchRoute = (routeName: string): void => {
      closeSwitcher();
      overlay.showOverlay();
      router.push({ name: routeName });
    };

    const selectedRoute: Ref<string> = computed(() => store.state.currentRoute.name as string);

    onMounted(() => {
      if (selectedRoute.value !== 'Map') {
        overlay.showOverlay();
      }
    });

    return {
      menuSwitcher,
      closeSwitcher,
      showMap,
      switchRoute,
      getContrastActive,
      selectedRoute,
      ...useHandleDrawer(),
      ...useManualMapUpdate(),
      ...useOptions(),
      ...overlay,
    };
  },
});
export default TopBar;
